jQuery(document).ready(function ($) {

    $('#toggleSearch').click(function (){
        let navigation = $('#top-navigation');
        let toggleMenu = $('#toggleMenu');
        navigation.find('.mobile-search').toggleClass('show');
        navigation.find('.mobile-menu').removeClass('show');
        toggleMenu.find('.close-icon').addClass('d-none');
        toggleMenu.find('.burger-icon').removeClass('d-none');
        if (navigation.find('.mobile-search').hasClass('show')) {
            $(this).find('.search-icon').addClass('d-none');
            $(this).find('.close-icon').removeClass('d-none');
        } else {
            $(this).find('.close-icon').addClass('d-none');
            $(this).find('.search-icon').removeClass('d-none');
        }
    });

});